export const NEWSLETTER_CONSENT_TEXT = 'Quiero recibir Novedades Tipi por email. Puedo darme de baja cuando quiera.';
export const NEWSLETTER_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export const NEWSLETTER_SOURCE_MAX_LENGTH = 200;
export const normalizeNewsletterEmail = (email) => email.trim().toLowerCase();
export const isValidNewsletterEmail = (email) => NEWSLETTER_EMAIL_REGEX.test(email);
export const clampNewsletterSource = (source) => source.trim().slice(0, NEWSLETTER_SOURCE_MAX_LENGTH);
//# sourceMappingURL=subscribeNewsletter.js.map